import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import Header, {
  NoHeaderScroll,
  HomeHeaderLeft,
} from "../../components/navigation/header";
import PlayerSelect from "../../components/playerSelect";

export default function QuizPlayer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [player, setPlayer] = useState(0);

  const handleOnClick = () => {
    if (player === 0) {
      return;
    }
    navigate("/quiz/game", {
      state: { player },
    });
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HomeHeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="ps-5 pe-5">
        <PlayerSelect
          description={t("txtJogador1")}
          player={player}
          setPlayer={setPlayer}
          onClick={handleOnClick}
        />
      </NoHeaderScroll>
    </div>
  );
}
